/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const primaryJourneys = [
  // Aka essential journeys
  'Show Immediately',
  'Blood Sugar',
  'Stress',
  'Sleep',
  'BP and Cholesterol',
  'Activity',
] as const;

export const secondaryJourneys = [
  // Aka non-essential journeys
  'Newly Diagnosed DM',
  'Pregnancy',
  'Alcohol',
  'Nicotine',
  'BMI',
  'Caffeine',
  'Opioid',
  'Injectable DM Drug',
  'Cannabis',
  'Pharmacy Visit #1',
  'Pharmacy Visit #2',
  'Pharmacy Visit #3',
  'Pharmacy Visit #4',
] as const;

export const allJourneys = [...primaryJourneys, ...secondaryJourneys] as const;
// Map of journey name to its index
export const journeyNameToIndex = new Map(allJourneys.map((journey, index) => [journey, index]));

// eslint-disable-next-line prettier/prettier
export type PrimaryJourneyType = (typeof primaryJourneys)[number];
// eslint-disable-next-line prettier/prettier
export type SecondaryJourneyType = (typeof secondaryJourneys)[number];
export type JourneyType = PrimaryJourneyType | SecondaryJourneyType;

export type UserState = {
  watchedVideosSinceLastQuiz: number; // To keep track of when to next show a quiz
  lastJourneysWatched: JourneyType[]; // Newest first, to check if there are priority videos we should show but haven't shown yet
  lastJourneysWatchedDate: Date[]; // Date of when the above journeys were watched
};

export type UserData = {
  flaggedJourneys: JourneyType[]; // These are known to be abnormally high/low
  nonFlaggedJourneys: PrimaryJourneyType[]; // These are known to good (in range)
  seenVignettes: Set<string>; // Already watched
  currentState?: UserState;
};
